require('./accountSettlementsDetailsView.scss')
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const moment = require('moment');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { EmptyState } = require('commonsComponents/emptyState');
// @ actions
const accountsActions = require('actions/getAccounts');
const { getLastNChars } = require('utilities/stringHelper');
const accountsSettlementsDetailsActions = require('actions/accountSettlementsDetails');

// @ Loans
const { okLoansComponents } = require('ok-loans');

// @ components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountSettlementsDetails = require('components/accounts/accountSettlementsDetails/accountSettlementsDetails');
const AccountSettlementsInfo = require('components/accounts/accountSettlementsInfo/accountSettlementsInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');
const LoansCreditsMoreOptionsButton = okLoansComponents.loansCreditsMoreOptionsButton;
// @ constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
//@utilities
const AccessHelper = require('utilities/accessHelper');

class AccountSettlementsDetailsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { accountId, settlementId } }, immAccounts, immSettlements, requestAccountsSettlementsDetails } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_SETTLEMENTS_DETAILS, { immAccounts, accountId, immSettlements, settlementId }, history);
        requestAccountsSettlementsDetails(accountId, settlementId);
    }

    buildEmptyOrError(accountId, primaryText) {
        const title = formatText('accountSettlementsDetails-settlement');
        const backToSettlementLink = `/myprofile/accounts/${accountId}/settlements`;
        const linkText = formatText('accountSettlementsDetails-backToSettlementLinkLabel');

        return (
            <EmptyState
                primaryText={primaryText}
                title={title}
                linkText={linkText}
                linkURL={backToSettlementLink}
                iconType="noitems-banking" />
        );
    }

    formatDateFromPeriod(dateStr, originCountry) {
        return moment(dateStr).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT);
    }

    render() {
        const {
            match: { params: { accountId,
                settlementId,
                creditType
            } },
            location: { pathname },
            immAccounts,
            immSettlements,
            originCountry
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const immAccountSettlements = immSettlements.get(accountId);
        const isInvestmentCredit = pathname.indexOf('/investment/') !== -1;

        // We will redirect to settlements view if settlement was not found
        if (!immAccountSettlements || !immAccountSettlements.getIn(['byId', settlementId])) {
            return <div />;
        }

        const immSettlement = immAccountSettlements.getIn(['byId', settlementId]);
        const subtitleLeft = immAccount.getIn(['catalogData', 'subtype']);
        const subtitleRight = getLastNChars(immAccount.get('iban'));

        const settlementDateFrom = this.formatDateFromPeriod(immSettlement.get('dateFrom'), originCountry);
        const settlementDateTo = this.formatDateFromPeriod(immSettlement.get('dateTo'), originCountry);
        const breadcrumbLastLevelLabel = formatText('accountSettlementsDetails-title', [settlementDateFrom, settlementDateTo])

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: !creditType ? `/myprofile/accounts/${accountId}/movements` : `/myprofile/loans-mortgages/credit/investment-credit/${accountId}`
            },
            {
                text: formatText('breadcrumb-accountSettlements'),
                url: !creditType ? `/myprofile/accounts/${accountId}/settlements` : `/myprofile/loans-mortgages/credit/${accountId}/${creditType}/settlements`
            },
            {
                text: breadcrumbLastLevelLabel,
                url: `/myprofile/accounts/${accountId}/settlements/${settlementId}`
            }
        ];

        let content, moreOptionsButton;
        const immSettlementsDetails = immSettlement.get('details');

        if (!!immSettlementsDetails.get('loading')) {
            content = <LoadingSection />;
        } else if (!!immSettlementsDetails.get('error')) {
            const primaryText = formatText('accountSettlementsDetails-errorMessage');
            content = this.buildEmptyOrError(accountId, primaryText);
        } else if (immSettlementsDetails.get('byOrder').size > 0) {
            content = (
                <AccountSettlementsDetails
                    immSettlementsDetails={immSettlementsDetails}
                />
            );
        } else {
            const primaryText = formatText('accountSettlementsDetails-emptyMessage');
            content = this.buildEmptyOrError(accountId, primaryText);
        }

        if (creditType) {
            moreOptionsButton = <LoansCreditsMoreOptionsButton id={accountId} type={creditType} />
        } else {
            moreOptionsButton = <AccountMoreOptionsButton accountId={accountId} />;
        }

        return (
            <section className="account-settlements-details-view">
                <OKCover size="medium" section="accounts">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        subtitleLeft={subtitleLeft}
                        subtitleRight={subtitleRight}
                        finalTitle={getFinalTitle('accountSettlementsDetails-title', [settlementDateFrom, settlementDateTo])}
                    >
                        {moreOptionsButton}
                    </OKHeaderSubPage>
                </OKCover>
                <div className="account-settlements-details-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <OKSectionBox>
                                {content}
                            </OKSectionBox>
                        </div>
                        <div className="col-xs-4">
                            <AccountSettlementsInfo
                                immAccount={immAccount}
                                immSettlement={immSettlement}
                                isInvestmentCredit={isInvestmentCredit}
                            />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

AccountSettlementsDetailsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immSettlements: PropTypes.object,
    requestAccounts: PropTypes.func.isRequired,
    requestAccountsSettlementsDetails: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    originCountry: PropTypes.string
};

module.exports.constructor = AccountSettlementsDetailsView;
module.exports.AccountSettlementsDetailsView = connect(
    state => ({
        immAccounts: state.accounts,
        immSettlements: state.accountsSettlements,
        originCountry: state.profile.get('originCountry')
    }), {
    requestAccounts: accountsActions.requestAccounts,
    requestAccountsSettlementsDetails: accountsSettlementsDetailsActions.requestSettlementsDetails
})(withRouter(AccountSettlementsDetailsView));
